import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { SupportList } from "../../../../components/SupportComponent";
import { useAuth } from "../../../../hooks";
import "./Page_Support_Partner.scss";

export function Page_Support_Partner() {
  const [reload, setReload] = useState(false);

  // Para forzar la recarga de la lista de tickets
  const onReload = () => setReload((prevState) => !prevState);

  const { accessToken, user } = useAuth();

  // Configuramos un único Tab con la lista de tickets
  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <SupportList
            reload={reload}
            onReload={onReload}
            user={user} // le pasamos el user
            accessToken={accessToken} // y el token
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="support-partner-page">
      <Tab menu={{ secondary: true }} panes={panes} />
    </div>
  );
}
